function youtubeVideoId(url) {
  let parsed;
  try {
    parsed = new URL(String(url || '').replace(/&amp;/g, '&'));
  } catch {
    return null;
  }
  const host = parsed.hostname.replace(/^www\./, '').replace(/^m\./, '');
  const idOk = (id) =>
    id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  if (host === 'youtu.be') {
    return idOk(parsed.pathname.split('/').filter(Boolean)[0]);
  }
  if (
    host === 'youtube.com' ||
    host === 'youtube-nocookie.com' ||
    host === 'music.youtube.com'
  ) {
    if (parsed.pathname === '/watch') return idOk(parsed.searchParams.get('v'));
    const parts = parsed.pathname.split('/').filter(Boolean);
    if (['embed', 'shorts', 'live', 'v'].includes(parts[0])) return idOk(parts[1]);
  }
  return null;
}

function youtubeThumbnailUrl(id) {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

function appendYoutubePreviews(html) {
  if (!html) return html || '';
  return String(html).replace(
    /<a\b([^>]*?)href="([^"]+)"([^>]*)>([\s\S]*?)<\/a>/gi,
    (anchor, before, href, after, label, offset, full) => {
      const attrs = `${before} ${after}`;
      if (/chat-video-preview/.test(attrs)) return anchor;
      const next = String(full).slice(offset + anchor.length);
      if (next.startsWith('<a class="chat-video-preview"')) return anchor;
      const id = youtubeVideoId(href);
      if (!id) return anchor;
      const src = youtubeThumbnailUrl(id);
      const alt = String(label || 'Video preview')
        .replace(/<[^>]+>/g, '')
        .replace(/"/g, '&quot;');
      return (
        `${anchor}<a class="chat-video-preview" href="${href}" target="_blank" rel="noopener noreferrer">` +
        `<img src="${src}" alt="${alt}" />` +
        `</a>`
      );
    },
  );
}

function finishStaffChatMarkdown(html, origin = '') {
  const linked = String(html || '').replace(
    /<a href="([^"]+)">([^<]*)<\/a>/g,
    (match, href, label) => {
      const isSameOrigin =
        href.startsWith('/') ||
        href.startsWith('#') ||
        (origin && href.startsWith(origin));
      if (isSameOrigin || href.startsWith('tel:')) {
        return `<a href="${href}">${label}</a>`;
      }
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${label}</a>`;
    },
  );
  return appendYoutubePreviews(linked);
}

module.exports = {
  youtubeVideoId,
  youtubeThumbnailUrl,
  appendYoutubePreviews,
  finishStaffChatMarkdown,
};
